// extracted by mini-css-extract-plugin
export default {"parent":"Container_parent__HWxjW","parent__children":"Container_parent__children__RNs8x"};